export interface ApiExportDisclosureRequest {
    task_id: string;
    title: string;
    data: {
        title: string;
        content: string;
        parent_title: string;
    }[]
}

export const ExportDisclosure = Symbol('ExportDisclosure');

export interface ExportDisclosure {
    exportDisclosure(data: ApiExportDisclosureRequest): Promise<string>;
}
